// @ts-nocheck
import { Globe } from 'lucide-react'

const COMMON_TIMEZONES = [
  { value: 'Asia/Tokyo', label: '日本 (Asia/Tokyo) - JST (UTC+9)' },
  { value: 'Asia/Seoul', label: '韓国 (Asia/Seoul) - KST (UTC+9)' },
  { value: 'Asia/Shanghai', label: '中国 (Asia/Shanghai) - CST (UTC+8)' },
  { value: 'Asia/Hong_Kong', label: '香港 (Asia/Hong_Kong) - HKT (UTC+8)' },
  { value: 'Asia/Singapore', label: 'シンガポール (Asia/Singapore) - SGT (UTC+8)' },
  { value: 'Asia/Bangkok', label: 'タイ (Asia/Bangkok) - ICT (UTC+7)' },
  { value: 'Asia/Kolkata', label: 'インド (Asia/Kolkata) - IST (UTC+5:30)' },
  { value: 'Asia/Dubai', label: 'UAE (Asia/Dubai) - GST (UTC+4)' },
  { value: 'Europe/London', label: 'イギリス (Europe/London) - GMT (UTC+0)' },
  { value: 'Europe/Paris', label: 'フランス (Europe/Paris) - CET (UTC+1)' },
  { value: 'Europe/Berlin', label: 'ドイツ (Europe/Berlin) - CET (UTC+1)' },
  { value: 'America/New_York', label: 'アメリカ東部 (America/New_York) - EST (UTC-5)' },
  { value: 'America/Chicago', label: 'アメリカ中部 (America/Chicago) - CST (UTC-6)' },
  { value: 'America/Denver', label: 'アメリカ山岳部 (America/Denver) - MST (UTC-7)' },
  { value: 'America/Los_Angeles', label: 'アメリカ西部 (America/Los_Angeles) - PST (UTC-8)' },
  { value: 'Pacific/Auckland', label: 'ニュージーランド (Pacific/Auckland) - NZST (UTC+12)' },
  { value: 'Australia/Sydney', label: 'オーストラリア東部 (Australia/Sydney) - AEDT (UTC+11)' },
]

export default function TimezoneSelector({ timezone, onChange }) {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm overflow-hidden">
      <div className="p-6 border-b border-gray-200 dark:border-gray-700">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-green-100 dark:bg-green-900/30 rounded-lg flex items-center justify-center">
            <Globe className="w-5 h-5 text-green-600 dark:text-green-400" />
          </div>
          <div>
            <h3 className="text-md font-semibold text-gray-900 dark:text-white">タイムゾーン</h3>
            <p className="text-sm text-gray-500 dark:text-gray-400">
              営業時間を判定する際のタイムゾーンを選択
            </p>
          </div>
        </div>
      </div>
      <div className="p-6">
        <select
          value={timezone}
          onChange={(e) => onChange(e.target.value)}
          className="w-full px-4 py-2.5 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        >
          {COMMON_TIMEZONES.map((tz) => (
            <option key={tz.value} value={tz.value}>
              {tz.label}
            </option>
          ))}
        </select>
        <p className="mt-2 text-xs text-gray-500 dark:text-gray-400">
          選択したタイムゾーンに基づいて営業時間の判定が行われます
        </p>
      </div>
    </div>
  )
}
